import React from 'react';
import {observer} from 'mobx-react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {withState} from 'shared/core';
import ExpensesPageState from 'main/containers/expenses/state/ExpensesPageState';
import MyExpensesContainer from 'main/containers/expenses/components/my_expenses/components/MyExpensesContainer';
import ExpenseRequestsContainer from 'main/containers/expenses/components/expense_requests/components/ExpenseRequestsContainer';
import ExpenseRequestDetailsContainer from './expense_requests/components/ExpenseRequestDetailsContainer';
import ManageContainer from 'main/containers/expenses/components/manage/components/ManageContainer';
import {PolicyEditFlow} from './manage/components/policies/components/edit';
import {EditExpenseContainer} from './edit/components';

const ExpensesPage = observer(({uiState}) => {
  const {scope} = uiState;

  return (
    <Router basename='/expenses'>
      <Switch>
        <Route exact path='/' render={({history}) => <MyExpensesContainer history={history} scope={scope}/>}/>
        <Route exact path='/expense_requests/new' render={({history}) => <EditExpenseContainer history={history} scope={scope} action='new'/>}/>
        <Route exact path='/expense_requests/:id/edit/:backPath?' render={({match, history}) => <EditExpenseContainer match={match} history={history} scope={scope} action='edit'/>}/>
        <Route path='/expense_requests/:id/:backPath?' render={({match, history}) => <ExpenseRequestDetailsContainer match={match} history={history} scope={scope}/>}/>
        {scope.expenseRequests && <Route exact path='/expense_requests' render={() => <ExpenseRequestsContainer scope={scope}/>}/>}
        {scope.manage && <Route path='/manage/policies/:id/edit' component={PolicyEditFlow}/>}
        {scope.manage && <Route path='/manage' render={({history}) => <ManageContainer history={history} scope={scope}/>}/>}
      </Switch>
    </Router>
  );
});

export default withState(ExpensesPage, ExpensesPageState);
